import { SystemDescriptions } from "src/common/descriptions";
import { formatToCurrency, formatToDisplayDatetime } from "src/common/util";
import { SummaryType } from "src/components/SearchableTable/types";
import { searchableTableUtils } from "src/components/SearchableTable/utils";
import { Image } from 'antd';
import { TransactionContractReceiptData } from "src/common/models/transactionContractPayment";
import { Assets } from "src/common/assets";

const descriptions = SystemDescriptions.PAGES.PAYABLE_CONTRACT.PAYABLE_CONTRACT_PAYMENTS

export enum ColumnsKeys {
    NO = 'key',
    DATETIME = 'datetime',
    SERVICE_CONTRACT_DEBIT_ID = 'serviceContractDebitId',
    AMOUNT = 'amount',
    CASH = 'cash',
    TRANSACTION = 'transaction',
    DISSCOUNT = 'disscount',
    COMMENT = 'comment',
    ACTIONS = 'ACTIONS',
    CUSTOMER = 'customer',
    DESCRIPTION = 'description',
    RECEIPT_DATA = 'receiptData',
}

export const TABLE_COLUMNS: any = [
    {
        title: descriptions.TABLE_COLUMNS.ID,
        dataIndex: ColumnsKeys.NO,
        key: ColumnsKeys.NO,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.DATETIME,
        dataIndex: ColumnsKeys.DATETIME,
        key: ColumnsKeys.DATETIME,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToDisplayDatetime(value)
    },
    {
        title: descriptions.TABLE_COLUMNS.DESCRIPTION,
        dataIndex: ColumnsKeys.DESCRIPTION,
        key: ColumnsKeys.DESCRIPTION,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.TOTAL,
        dataIndex: ColumnsKeys.AMOUNT,
        key: ColumnsKeys.AMOUNT,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },
    {
        title: descriptions.TABLE_COLUMNS.CASH,
        dataIndex: ColumnsKeys.CASH,
        key: ColumnsKeys.CASH,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },
    {
        title: descriptions.TABLE_COLUMNS.TRANSACTION,
        dataIndex: ColumnsKeys.TRANSACTION,
        key: ColumnsKeys.TRANSACTION,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },
    {
        title: descriptions.TABLE_COLUMNS.DISSCOUNT,
        dataIndex: ColumnsKeys.DISSCOUNT,
        key: ColumnsKeys.DISSCOUNT,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },
    {
        title: descriptions.TABLE_COLUMNS.RECEIPT,
        dataIndex: ColumnsKeys.RECEIPT_DATA,
        key: ColumnsKeys.RECEIPT_DATA,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => {
            let url: string | undefined;

            try {
                const receiptData = JSON.parse(value) as TransactionContractReceiptData[];
                url = receiptData?.[0]?.url;
            } catch (error) {
                console.error("Failed to parse receipt data:", error);
            }

            return (
                url
                    ? <Image
                        width={40}
                        src={url || Assets.NO_IMAGE_ITEM}
                        alt="Receipt"
                    />
                    : '--'
            );
        },
    },
];

export const summaryColumns: Partial<Record<ColumnsKeys, SummaryType>> = {
    [ColumnsKeys.AMOUNT]: SummaryType.SUM,
    [ColumnsKeys.CASH]: SummaryType.SUM,
    [ColumnsKeys.TRANSACTION]: SummaryType.SUM,
    [ColumnsKeys.DISSCOUNT]: SummaryType.SUM,
    [ColumnsKeys.NO]: SummaryType.COUNT,
}